import { Locale, type LocalizedString } from "../Locale.js";

export const helpCratesPathMap = {
	[Locale.cs]: "chci-skladovat-v-prepravkach" as const,
} satisfies LocalizedString;
